import { defineMessages } from 'react-intl';

export default defineMessages({

  cityOrTown: {
    id: 'fastCover.collisionDamageStep.cityOrTown',
    defaultMessage: 'City or Town',
  },

  country: {
    id: 'fastCover.collisionDamageStep.country',
    defaultMessage: 'Country',
  },

  postalCode: {
    id: 'fastCover.collisionDamageStep.postalCode',
    defaultMessage: 'Postal Code',
  },

  phoneNumber: {
    id: 'fastCover.collisionDamageStep.phoneNumber',
    defaultMessage: 'Phone Number',
  },

  currency: {
    id: 'fastCover.collisionDamageStep.currency',
    defaultMessage: 'Currency',
  },

  yes: {
    id: 'fastCover.collisionDamageStep.yes',
    defaultMessage: 'Yes',
  },

  no: {
    id: 'fastCover.collisionDamageStep.no',
    defaultMessage: 'No',
  },

  addItem: {
    id: 'fastCover.collisionDamageStep.addItem',
    defaultMessage: 'Add Expense',
  },

  itemWithIdx: {
    id: 'fastCover.collisionDamageStep.itemWithIdx',
    defaultMessage: 'Item(s) {idx}',
  },

  item: {
    id: 'fastCover.collisionDamageStep.item',
    defaultMessage: 'Item',
  },

  isRequired: {
    id: 'fastCover.collisionDamageStep.isRequired',
    defaultMessage: "'{defaultMessage}' is required",
  },

  checkEventDate: {
    id: 'fastCover.collisionDamageStep.checkEventDate',
    defaultMessage: "'{defaultMessage}' cannot be in the future.",
  },

  areYouClaimingForRentalCarDamage: {
    id: 'fastCover.collisionDamageStep.areYouClaimingForRentalCarDamage',
    defaultMessage: 'Are you claiming for Rental Car Damage?',
  },

  travelSupplierOrProviderInformation: {
    id: 'fastCover.collisionDamageStep.travelSupplierOrProviderInformation',
    defaultMessage: 'Travel Supplier / Provider Information',
  },

  nameOfTourOperatorOrCruiseOrLineOrAirline: {
    id: 'fastCover.collisionDamageStep.travelSupplierOrProviderInformation',
    defaultMessage: 'Name of Tour Operator/Cruise Line/Airline you were traveling with:',
  },

  lossInformation: {
    id: 'fastCover.collisionDamageStep.lossInformation',
    defaultMessage: 'Loss Information',
  },

  otherInsuranceAuthorization: {
    id: 'fastCover.collisionDamageStep.otherInsuranceAuthorization',
    defaultMessage: 'OTHER INSURANCE / AUTHORISATION:',
  },
  
  companyName: {
    id: 'fastCover.collisionDamageStep.companyName',
    defaultMessage: 'Company Name',
  },

  address: {
    id: 'fastCover.collisionDamageStep.address',
    defaultMessage: 'Address',
  },

  typeOfPolicy: {
    id: 'fastCover.collisionDamageStep.typeOfPolicy',
    defaultMessage: 'Type Of Policy',
  },

  policy: {
    id: 'fastCover.collisionDamageStep.policy',
    defaultMessage: 'Policy',
  },

  policyNumber: {
    id: 'fastCover.collisionDamageStep.policyNumber',
    defaultMessage: 'Policy Number',
  },

  contact: {
    id: 'fastCover.collisionDamageStep.contactF',
    defaultMessage: 'Contact',
  },

  phone: {
    id: 'fastCover.collisionDamageStep.phone',
    defaultMessage: 'Phone',
  },

  origination: {
    id: 'fastCover.collisionDamageStep.origination',
    defaultMessage: 'Origination',
  },

  flightNumber: {
    id: 'fastCover.collisionDamageStep.flightNumber',
    defaultMessage: 'Flight Number',
  },

  airCarrier: {
    id: 'fastCover.collisionDamageStep.airCarrier',
    defaultMessage: 'Air Carrier',
  },

  destination: {
    id: 'fastCover.collisionDamageStep.destination',
    defaultMessage: 'Destination',
  },

  companyNameLoss: {
    id: 'fastCover.collisionDamageStep.companyNameLoss',
    defaultMessage: 'Company name (airline/hotel/cruse/travel agent/ect.)',
  },

  amountPaidLoss: {
    id: 'fastCover.collisionDamageStep.amountPaidLoss',
    defaultMessage: 'Amount Paid',
  },

  amountOfLoss: {
    id: 'fastCover.collisionDamageStep.amountOfLoss',
    defaultMessage: 'Amount of Loss (non-refundable amount)',
  },

  howMuchReceivedReimbursement: {
    id: 'fastCover.collisionDamageStep.howMuchReceivedReimbursement',
    defaultMessage: 'How much?',
  },

  haveYouReceivedReimbursement: {
    id: 'fastCover.collisionDamageStep.haveYouReceivedReimbursement',
    defaultMessage: 'Have you received reimbursement?',
  },

  delayInformationWithIdx: {
    id: 'fastCover.collisionDamageStep.delayInformationWithIdx',
    defaultMessage: 'Delay information {idx}',
  },

  fromWhom: {
    id: 'fastCover.collisionDamageStep.fromWhom',
    defaultMessage: 'It so, from whom?',
  },

  dateReimbursementReceived: {
    id: 'fastCover.collisionDamageStep.dateReimbursementReceived',
    defaultMessage: 'Date Reimbursement Received',
  },

  estimatedValue: {
    id: 'fastCover.collisionDamageStep.estimatedValue',
    defaultMessage: 'Estimated Value',
  },

  dateOfLoss: {
    id: 'fastCover.collisionDamageStep.dateOfLoss',
    defaultMessage: 'Date Of Loss',
  },

  pleaseDescribeWhatOccurred: {
    id: 'fastCover.collisionDamageStep.pleaseDescribeWhatOccurred',
    defaultMessage: 'Please Describe What Occurred',
  },

  placeOfLoss: {
    id: 'fastCover.collisionDamageStep.placeOfLoss',
    defaultMessage: 'Place Of Loss',
  },

  itemDescription: {
    id: 'fastCover.collisionDamageStep.itemDescription',
    defaultMessage: 'Item Description',
  },

  schoolName: {
    id: 'fastCover.collisionDamageStep.schoolName',
    defaultMessage: 'School Name',
  },
});



// WEBPACK FOOTER //
// ./app/containers/FastCover/Trawick.NationWide.CollisionDamageStep/messages.js